import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import {
  getOptionsFromRefList,
  generateRules,
  isNonEmptyVariable,
  formatDropDownOptions,
  formatDropDownOptionsWithRefListId,
} from "@/util/common_function";
import { Form } from "antd";
import { forwardRef, useImperativeHandle, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";

const EmergencyForm = forwardRef(
  ({ formData, updateForm, bookingsFieldsEnabled }) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { bookings } = useSelector((s) => s?.bookings);

    useEffect(() => {
      form.setFieldsValue(formData);
    }, [formData]);

    const changeIsActive = (e) => {
      const isActive = e?.target?.checked;
      dispatch(
        setBookings({
          isActive: isActive,
        })
      );
    };

    return (
      <>
        <Form
          form={form}
          disabled={!bookingsFieldsEnabled}
          initialValues={formData}
          onBlur={() => {
            const values = form.getFieldsValue();
            updateForm(values);
          }}
        >
          <StyledGridRow gutter={16}>
            <StyledGridCol span={6}>
              <FormItem name="emergencyContact" label="Emergency Contact">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem
                name="emergencyContactRelationshipId"
                label="Relationship"
              >
                <Select
                  options={getOptionsFromRefList(
                    "Emergency_Contact_Relationship",
                    false,
                    false,
                    true
                  )}
                  placeholder="Relationship"
                  showSearch={true}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem name="emergencyPhone" label="Emergency Phone">
                <TextField type="number" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem name="emergencyAddress" label="Emergency Address">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem name="physicianName" label="Physician Name">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem name="physicianPhone" label="Physician Phone">
                <TextField type="number" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={6}>
              <FormItem name="bloodType" label="Blood Type">
                <Select
                  options={getOptionsFromRefList("BloodType")}
                  placeholder="Blood Type"
                  showSearch={false}
                  variant="outlined"
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={12} xl={8}>
              <FormItem
                label="Active Staff Member?"
                layout="horizontal"
                labelPostion="label-right"
                className="checkbox-control"
                //   name="isActive"
                valuePropName="checked"
              >
                <Checkbox
                  checked={bookings?.isActive}
                  onChange={changeIsActive}
                  disabled={!bookingsFieldsEnabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </>
    );
  }
);
export default EmergencyForm;
